import React from 'react';

/**
 * 下箭头图标（用于「查看更多」等）
 */
export const DownArrowIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    width="16"
    height="16"
    {...props}
  >
    <g>
      <path
        d="M13.67138671875,6.2859392166137695C13.67138671875,6.2859392166137695,15.00472011875,6.2859392166137695,15.00472011875,6.2859392166137695C15.00472011875,6.2859392166137695,15.00472011875,12.95260621661377,15.00472011875,12.95260621661377C15.00472011875,12.95260621661377,21.67138671875,12.95260621661377,21.67138671875,12.95260621661377C21.67138671875,12.95260621661377,21.67138671875,14.28593921661377,21.67138671875,14.28593921661377C21.67138671875,14.28593921661377,14.33811342875,14.28593921661377,14.33811342875,14.28593921661377C14.33811342875,14.28593921661377,14.33805340875,14.28593921661377,14.33805340875,13.61927271661377C14.33805340875,13.61927271661377,14.33811342875,14.28593921661377,14.33811342875,14.28593921661377C14.33811342875,14.28593921661377,13.67138711611335,14.28593921661377,13.67138711611335,14.28593921661377C13.67138711611335,14.28593921661377,13.67138671875,6.2859392166137695,13.67138671875,6.2859392166137695C13.67138671875,6.2859392166137695,13.67138671875,6.2859392166137695,13.67138671875,6.2859392166137695Z"
        fillRule="evenodd"
        fill="currentColor"
        transform="matrix(-0.7071068286895752,-0.7071067094802856,-0.7071067094802856,0.7071068286895752,27.783347420686937,11.508237948546366)"
      />
    </g>
  </svg>
);
